export default {
  env: 'staging',
  sentryDsn:
    'https://2707528caf794446be87b06c7cf35256@o933210.ingest.sentry.io/5883995'
}
